import React, {useState} from "react";
import PropTypes from 'prop-types';
import { Document, Page } from "react-pdf";

const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true
};


const ViewDocument = (props) => {
    const { document, documentImage } = props;
    const { documentTypeText } = document;
    const [file, setFile] = useState(documentImage);
    const [numPages, setPageNumber] = useState(null);

    const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
        setPageNumber(nextNumPages);
    }

    return (
        <div>
            <div>
                {documentTypeText === "PDF" &&
                <div style={{ height: '-webkit-fill-available;', overflow: "auto" }}>

                    <Document
                        file={file}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={console.error}
                        options={options}
                    >
                        {
                            Array.from(
                                new Array(numPages),
                                (el, index) => (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                    />
                                ),
                            )
                        }
                    </Document>
                </div>
                }
                {documentTypeText === "Image" &&
                <div>
                    <img src={`data:image/png;base64,${documentImage}`}  alt="sampleImg" style={{width: "100%", height: "100%", objectFit: "cover"}}/>
                </div>
                }
                {documentTypeText === "Unknown" &&
                <div>
                    <p>Unknown Document Type</p>
                </div>
                }
            </div>
        </div>
    )
}

ViewDocument.propTypes = {
    document: PropTypes.object.isRequired,
    documentImage: PropTypes.array.isRequired
}

export default ViewDocument;